export default "__VITE_ASSET__0446024e__"